import useRemoveUser from './useRemoveUser'

export default useRemoveUser
